import React from 'react';

const Navbar = () => (
  <div className="navbar">
    <h1>Duty-Generator 😎🇷🇼</h1>

  </div>
);

export default Navbar;
